import React, { useState } from "react";
import { Alert } from "antd";
import Axios from "axios";
import { TextInput } from "../../../components/globals";
import { CheckBoxInput } from "../../../components/common/Buttons";
import { FlopppyButton } from "../../../components/common/ButtonWithLoading";
import { useMutation, useQueryClient } from "react-query";
import { antdMessageSuccess } from "../../../helpers/Utils";
import { colors } from "../../../utils/colors";

function PickupLeasingComponent({
  disabled,
  p_leasing_cod,
  p_leasing_number,
  p_leasing_discount,
  p_leasing_advance,
  orderId,
}) {
  const [variables, setVariables] = useState({
    leasing_cod: p_leasing_cod,
    leasing_number: p_leasing_number,
    leasing_discount: p_leasing_discount,
    leasing_advance: p_leasing_advance,
  });

  const { leasing_cod, leasing_number, leasing_discount, leasing_advance } =
    variables;

  const [alertText, setAlertText] = useState({
    success: "success",
    text: "",
    show: false,
  });

  const utils = useQueryClient();

  const mutationOrder = useMutation({
    mutationFn: (variables) => {
      return Axios.put(`/pickups/requests/update_order`, {
        order: variables,
        order_id: orderId,
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      await utils.invalidateQueries(["requests", { record_id: orderId }]);
      setAlertText({
        success: "success",
        text: "Sėkmingai atnaujinta.",
        show: true,
      });
      antdMessageSuccess();
    },
    onError: (error) => {
      setAlertText({
        success: "error",
        text: "Įvyko klaida atnaujinant.",
        show: true,
      });
      antdMessageError(error?.response?.data?.message);
    },
  });

  const onChangeHandler = (e) => {
    setVariables({
      ...variables,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <div className="col-12 py-4">
      {alertText.show && (
        <Alert message={alertText.text} type={alertText.success} showIcon />
      )}
      <div className="row">
        <div className="col-6">
          <TextInput
            disabled={disabled}
            text="Lizingo sutarties numeris"
            placeholder="Lizingo sutarties numeris"
            name="leasing_number"
            value={leasing_number}
            onChange={onChangeHandler}
          />
          <TextInput
            disabled={disabled}
            type="number"
            text="Lizingo nuolaida, EUR"
            placeholder="Lizingo nuolaida, EUR"
            name="leasing_discount"
            value={leasing_discount}
            onChange={onChangeHandler}
          />
        </div>
        <div className={`col-${disabled ? 6 : 4}`}>
          <TextInput
            disabled={disabled}
            type="number"
            text="Avansas"
            placeholder="Avansas"
            name="leasing_advance"
            value={leasing_advance}
            onChange={onChangeHandler}
          />
          <div className="text-bold my-1" style={{ visibility: "hidden" }}>
            Nuolaida 5090
          </div>
          <div className="mt-2">
            <CheckBoxInput
              disabled={disabled}
              choised="leasing_cod"
              name="leasing_cod"
              color="#f7951e"
              text="Lizingas COD"
              checked={leasing_cod}
              onChange={(e) =>
                onChangeHandler({
                  target: {
                    name: "leasing_cod",
                    value: e.target.checked,
                  },
                })
              }
            />
          </div>
        </div>
        {!disabled && (
          <div className="col-2 d-flex align-items-center justify-content-end">
            <div>
              <FlopppyButton
                style={{
                  backgroundColor: colors["orange"],
                }}
                loading={mutationOrder.isLoading}
                onClick={() => mutationOrder.mutate(variables)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PickupLeasingComponent;
